<template>
  <div class="planInfo">
    <div class="mainCon">
      <el-table :data="tableData">
        <el-table-column label="时段/星期" align="center" width="180">
          <template slot-scope="scope">
            <!-- <span style="margin-left: 10px" >{{ scope.row.gmtCreate }}~{{ scope.row.gmtModified }}</span> -->
            <span>{{ scope.row.periodValue }}</span>
            <div>能约{{ scope.row.volume }}人</div>
          </template>
        </el-table-column>
        <el-table-column label="周一" style="width: 9%">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-switch
                v-model="scope.row.monday"
                :active-value="1"
                :inactive-value="0"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周二" style="width: 9%">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-switch
                v-model="scope.row.tuesday"
                :active-value="1"
                :inactive-value="0"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周三" style="width: 9%">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.wednesday"
              :active-value="1"
              :inactive-value="0"
            />
          </template>
        </el-table-column>
        <el-table-column label="周四" style="width: 9%">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.thursday"
              :active-value="1"
              :inactive-value="0"
            />
          </template>
        </el-table-column>
        <el-table-column label="周五" style="width: 9%">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.friday"
              :active-value="1"
              :inactive-value="0"
            />
          </template>
        </el-table-column>
        <el-table-column label="周六" style="width: 9%">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.saturday"
              :active-value="1"
              :inactive-value="0"
            />
          </template>
        </el-table-column>
        <el-table-column label="周日" style="width: 9%">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.sunday"
              :active-value="1"
              :inactive-value="0"
            />
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="deleteRow(scope.row)"
              type="text"
              style="font-size: 20px"
              icon="el-icon-delete"
            >
            </el-button>
            <el-button
              type="text"
              icon="el-icon-s-tools"
              style="font-size: 20px"
              @click="handleEdit(scope.$index, scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="plan_btn">
        <el-button @click="addPeriodBtn">添加时段</el-button>
        <el-button type="primary" @click="subAll">保存</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="30%">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="工作时间">
          <el-col :span="11">
            <el-time-picker
              placeholder="开始时间"
              v-model="form.startDate"
              format="HH:mm"
              value-format="HH:mm"
              style="width: 100%"
            ></el-time-picker>
          </el-col>
          <el-col class="line" style="text-align: center" :span="2">-</el-col>
          <el-col :span="11">
            <el-time-picker
              placeholder="结束时间"
              v-model="form.endDate"
              format="HH:mm"
              value-format="HH:mm"
              style="width: 100%"
            ></el-time-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="服务人数">
          <el-input-number
            v-model="form.volume"
            :min="0"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onConfirmBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from "@/utils";
import {
  getSchedule,
  delPeriod,
  addPeriod,
  addSchedule,
  editPeriod,
} from "@/api";
export default {
  name: "planPhone",
  data() {
    return {
      jsonPlan: {},
      tableData: [],
      scope: "",
      dialogVisible: false,
      form: {
        volume: 0,
        startDate: "",
        endDate: "",
      },
      type: "add",
      dataId: "",
      dataIndex: 0,
    };
  },
  created() {
    this.getSchedule();
  },
  methods: {
    // 点击添加时段
    addPeriodBtn() {
      this.dialogVisible = true;
      this.form.startDate = "";
      this.form.endDate = "";
      this.form.volume = 0;
      this.type = "add";
    },
    // 点击修改时段
    handleEdit(index, row) {
      this.dataId = row.periodId;
      this.form.volume = row.volume;
      this.form.startDate = row.periodValue.split("-")[0];
      this.form.endDate = row.periodValue.split("-")[1];
      this.dataIndex = index;
      this.dialogVisible = true;
      this.type = "edit";
    },
    // 点击确定
    onConfirmBtn() {
      if (this.type == "add") {
        this.addPeriod();
      } else {
        this.editPeriod();
      }
    },
    // 保存全部
    async subAll() {
      if (!this.tableData) return this.$message.error("清先添加时段");
      const params = {
        doctorId: utils.getStore("user_id"),
        serviceId: "3",
        doctorScheduleJobList: this.tableData,
      };
      const res = await addSchedule(params);
      this.getSchedule();
    },
    // 添加时段
    async addPeriod() {
      const params = {
        serviceId: "3",
        doctorId: utils.getStore("user_id"),
        // periodValue: this.form.startDate + "-" + this.form.endDate,
        periodStart: this.form.startDate,
        periodEnd: this.form.endDate,
        periodName: this.form.startDate + "-" + this.form.endDate,
      };
      const res = await addPeriod(params);
      if (!this.tableData) {
        this.tableData = [];
        this.tableData.push({
          // periodValue: this.form.startDate + "-" + this.form.endDate,
          periodStart: this.form.startDate,
          periodEnd: this.form.endDate,
          periodId: res.data.id,
          monday: 0,
          tuesday: 0,
          wednesday: 0,
          thursday: 0,
          friday: 0,
          saturday: 0,
          sunday: 0,
          volume: this.form.volume,
          isWeekend: 0,
        });
      } else {
        this.tableData.push({
          // periodValue: this.form.startDate + "-" + this.form.endDate,
          periodStart: this.form.startDate,
          periodEnd: this.form.endDate,
          periodId: res.data.id,
          monday: 0,
          tuesday: 0,
          wednesday: 0,
          thursday: 0,
          friday: 0,
          saturday: 0,
          sunday: 0,
          volume: this.form.volume,
          isWeekend: 0,
        });
      }

      this.dialogVisible = false;
      this.addSchedule(res.data.id);
    },
    // 修改时段
    async editPeriod() {
      const params = {
        doctorId: utils.getStore("user_id"),
        // periodValue: this.form.startDate + "-" + this.form.endDate,
        periodStart: this.form.startDate,
        periodEnd: this.form.endDate,
        periodName: this.form.startDate + "-" + this.form.endDate,
        id: this.dataId,
      };
      const res = await editPeriod(params);
      (this.tableData[this.dataIndex].periodValue =
        this.form.startDate + "-" + this.form.endDate),
        (this.tableData[this.dataIndex].volume = this.form.volume);
      this.dialogVisible = false;
      this.addSchedule();
      // this.getSchedule()
    },
    // 添加排期
    async addSchedule() {
      const params = {
        doctorId: utils.getStore("user_id"),
        serviceId: "3",
        doctorScheduleJobList: this.tableData,
      };
      const res = await addSchedule(params);
      this.getSchedule();
    },
    // 移除
    async deleteRow(row) {
      const params = {
        periodId: row.periodId,
      };
      const res = await delPeriod(params);
      this.getSchedule();
    },
    // 获取排期列表
    async getSchedule() {
      const params = {
        doctorId: utils.getStore("user_id"),
        serviceId: "3",
      };
      const res = await getSchedule(params);
      if (res.code == 1) {
        this.tableData = res.data;
      }
    },

    async getPlan() {
      try {
        const params = {
          morning: {
            week: this.tableData[0].week,
          },
          afternoon: {
            week: this.tableData[1].week,
          },
          night: {
            week: this.tableData[2].week,
          },
        };

        let res = await setServiceTime(params);
        if (res.success) {
        }
      } catch (error) {}
    },
    change: function(index, row) {},
    handleDelete(index, row) {},
    async getDutyInfo() {
      try {
        const params = {};
        let res = await getServiceTimeList(params);
        if (res.success) {
          let data = res.result;
          this.tableData[0].week = data.morning.week;
          this.tableData[1].week = data.afternoon.week;
          this.tableData[2].week = data.night.week;
        }
      } catch (error) {}
    },

    changeSwitch(val, row) {},
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-text {
  background: none !important;
  font-weight: bold;
  font-size: 18px;
  padding-top: 0px;
  display: flex;
  justify-content: center;
}
/deep/ .el-table__empty-text {
  margin: 20px !important;
  height: auto !important;
}
.name-wrapper {
  margin-left: 00px;
}
.planInfo {
  position: relative;
  width: 70%;
  margin: 20px;
  .mainCon {
    width: 100%;
    padding: 10px 0 0px 10px;
    border: 1px solid #ddd;
    box-shadow: 0 0 4px #ddd;
    .title {
      position: absolute;
      font-size: 20px;
      padding: 10px 0;
      margin-top: -30px;
    }
    .plan_btn {
      display: flex;
      justify-content: space-between;
      padding: 10px;
    }
    table {
      width: 100%;
    }
  }
}
</style>
